import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-50 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">
                Ladies Turf Cricket Rules and Regulations
              </h3>
              <ul>
                <li>
                  a. Common rules
                  <ul>
                    <li>• 2 Points per win</li>
                    <li>• NRR shall be calculated through CricHeroes App</li>
                    <li>• Equal points in case of a draw or no result</li>
                  </ul>
                </li>
              </ul>
              <h3>Playing Conditions</h3>
              <ul>
                <li>
                  • Total 7 players on the field. Only two fielders are allowed
                  beyond the half line.
                </li>
                <li>
                  • 7 overs should be bowled by every team in a Match and one
                  bowler can bowl maximum one over per match.
                </li>
                <li>
                  • If any player is injured and cannot bowl, then the team must
                  inform the same before the start of the match and in such case
                  even the opponent team will be allowed to use any bowler for 2
                  overs irrespective of the category of the injured Player. If
                  the injury happens in between the match, the right of deciding
                  the bowler should be given to the batting team.
                </li>
                <li>
                  • First over of every inning will be a Powerplay Over in which
                  only one fielder is allowed behind the bowling crease/half
                  line
                </li>
                <li>• Runner is allowed only for the injured Player.</li>
                <li>
                  • In case of Tie match, there will be super over till we get a
                  result.
                </li>
                <li>• Every No Ball will be given as Free hit.</li>
                <li>• Hit wicket will be given OUT.</li>
                <li>• Last Player cannot bat.</li>
                <li>
                  • There are runs for over throws, no ball, byes, legbyes and
                  wide.
                </li>
                <li>
                  • Teams should be present 15 mins before match starts
                  otherwise, opponent will be declared as winner.
                </li>
              </ul>
              <h3> GROUND RULES </h3>
              <ul>
                <li>
                  • If the ball hit the upper net, it will be declared OUT & if
                  the ball hits the side nets, it will be counted as a tap.
                </li>
                <li>
                  • If the ball hit the upper net and hits the boundary net
                  directly, it will be declared a SIX & if the ball hits the
                  side nets and hits the boundary net directly, it will be
                  declared as FOUR
                </li>
                <li>
                  • If ball goes outside of the turf through side nets (directly
                  or not), 2 runs will be declared
                </li>
                <li>
                  • If ball goes outside of the turf through the boundary net
                  (directly or not), 4/6 runs will be given.
                </li>
                <li>
                  • If ball goes outside of the turf through the net behind the
                  wicket keeper (directly or not), 1 run will be declared. The
                  batman will have to change the strike.
                </li>
                <li>
                  • If the ball taps twice before the bat, it will be declared
                  as a dead ball, no runs will be counted.
                </li>
                <li>
                  • The call of giving no ball on bowling fast than the allowed
                  speed limit will be given monitored through the speed checking
                  machine. The maximum allowed bowling speed is 70 km per hour.
                  There will not be any first warning.
                </li>
                <li>• Bowler can take 3-4 steps for bowliing</li>
                <li>
                  • Batsman is not allowed to retire except due to an
                  unfortunate injury and once retired, the batman cannot come
                  back to bat again in that inning.
                </li>
                <li>
                  • While bowling moving of only upper arm above the shoulder is
                  only allowed. Full arm bowling & under arm bowling is invalid
                  and the ball will be considered as no ball, resulting in a
                  free hit.
                </li>
                <li>• Mankading is allowed after a first warning.</li>
                <li>
                  • As per the new rules, after a wicket falls new batman will
                  be on the strike except if the batman is run out at the
                  non-strikers end.
                </li>
                <li>
                  • Not following field restrictions will result in a no ball
                  and a free hit
                </li>
                <li>
                  • If the keeper collects the ball before it passes the stumps
                  for the stumping, then the stumping will not be vaild and the
                  ball will be declared as a no ball resulting in to a free hit
                </li>
                <li>
                  • While bowling (at the time of follow-through) if bowler
                  disturbs the stumps, it will be declared as a no ball.
                </li>
                <li>
                  • Obstructing the field is out if umpires feel that the same
                  is deliberate.
                </li>
                <li>
                  • Maximum 25 minutes will be given per inning, in case of
                  delay following penalty will be levied which is - Once 25
                  minutes are over, only one fielder behind the bowling crease
                  will be allowed.
                </li>
                <li>• Fiber bats and plastic bats are not allowed</li>
                <li>
                  • Matches will be played with 1.5 MRI Tennis Balls (Light)
                </li>
                <li>
                  • Before the Toss in a match, both the captains must handover
                  the list of their playing Seven to the Umpires and No changes
                  will be allowed thereafter.
                </li>
                <li>• The wicket keeper is compulsory and can be rotated.</li>
                <li>
                  • Scoring of the tournament will be done in CricHeroes App. If
                  any discrepancies found in the scoring, the same should be
                  rectified immediately after the match by informing the Scorer.
                  No changes will be entertained later on.
                </li>
                <li>
                  • No need to inform bowling side change & keeper change to the
                  umpires.
                </li>
                <li>
                  • If the overthrow/batman’s shot hits batman, only boundary
                  will be allowed.
                </li>
                <li>• All the MCA Cricket rules are applicable.</li>
                <li>
                  • Umpires / Management committees decision will be considered
                  as final decision in case of any dispute
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
